import { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { AppDispatch } from '../../../redux/reducer/store';
import { actionGetProjectsList } from '../../../redux/action/projects/actionProjects';

import Loader from '../../custom/loader/loader';

import '../table.scss';

const TableProjectInfo: FC = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { limit, pages } = useSelector((state: any) => state.projects.projects);
    const actualLimit =
        JSON.parse(localStorage.getItem('pageLimit') as string) || limit;
    const [isPending, setIsPending] = useState<boolean>(true);
    useEffect(() => {
        setIsPending(true);
        dispatch(actionGetProjectsList(actualLimit, pages)).then(() => {
            setIsPending(false);
        });
    }, [actualLimit, dispatch, pages]);

    return (
        <>
            <div className='loader__wrapper'>{isPending && <Loader />}</div>
        </>
    );
};

export default TableProjectInfo;
